import { TooltipHover } from "components/designV2/tooltip/tooltip";
import { CustomIcon } from "components/icon/customIcon.component";
import { ColorV2 } from "config/colors";
import React from "react";
import { useTranslation } from "react-i18next";
import type { SelectedWorker } from "../modal/gigFormModal.types";

type Props = {
  readonly hasOverlapWarning: boolean;
  readonly overlappingWorkerNames: readonly string[];
  readonly workersWithoutEmployment: readonly SelectedWorker[];
};

export const ShiftWarning: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const employmentWarningWorkerNames = props.workersWithoutEmployment.map(
    (worker) => {
      const name = `${worker.firstName} ${worker.lastName}`.trim();
      return name || String(worker.workerId);
    },
  );
  const warningTooltipText = [
    props.hasOverlapWarning
      ? `${t("CreateShift.PeopleWithOverlappingShifts")}${
          props.overlappingWorkerNames.length > 0
            ? `:\n${props.overlappingWorkerNames.join("\n")}`
            : ""
        }`
      : null,
    employmentWarningWorkerNames.length > 0
      ? `${t("CreateShift.WorkersWithoutActiveEmployment")}:\n${employmentWarningWorkerNames.join(", ")}`
      : null,
  ]
    .filter((text): text is string => text !== null)
    .join("\n\n");

  if (!warningTooltipText) return null;

  return (
    <TooltipHover text={warningTooltipText} arrow="down" textAlign="left">
      <CustomIcon
        name="v2/warning-triangle"
        size="18px"
        color={ColorV2.NegativeRed}
      />
    </TooltipHover>
  );
};
